import gql from 'graphql-tag';

export const DeleteDraftMutationForRevertDialog = gql`
	mutation DeleteDraftMutationForRevertDialog($contentId: ID!) {
		deleteContent(contentId: $contentId, action: DELETE_DRAFT) {
			contentId
		}
	}
`;
